import DOMPurify from 'dompurify';

export function sanitizeCourseHtml(html) {
  const clean = DOMPurify.sanitize(html || '', {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'loading', 'data-youtube-video'],
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'input', 'button', 'style'],
  });
  const doc = new DOMParser().parseFromString(clean, 'text/html');
  doc.querySelectorAll('iframe').forEach(frame => {
    try {
      const url = new URL(frame.getAttribute('src'), window.location.origin);
      if (url.protocol !== 'https:' || !['www.youtube.com', 'www.youtube-nocookie.com'].includes(url.hostname) || !url.pathname.startsWith('/embed/')) frame.remove();
      else {
        frame.setAttribute('loading', 'lazy');
        frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        frame.style.width = '100%';
        frame.style.height = 'auto';
        frame.style.aspectRatio = '16 / 9';
        if (frame.parentElement?.classList.contains('youtube-wrapper')) frame.parentElement.removeAttribute('style');
      }
    } catch { frame.remove(); }
  });
  doc.querySelectorAll('[style]').forEach(node => {
    ['position', 'z-index', 'background-image', 'behavior', '-moz-binding'].forEach(property => node.style.removeProperty(property));
  });
  doc.querySelectorAll('a[target="_blank"]').forEach(link => link.setAttribute('rel', 'noopener noreferrer'));
  return doc.body.innerHTML;
}

export function unpackCourseHtml(html) {
  const doc = new DOMParser().parseFromString(sanitizeCourseHtml(html), 'text/html');
  const paper = doc.body.firstElementChild;
  if (paper?.hasAttribute('data-course-paper')) return { html: paper.innerHTML, color: paper.style.backgroundColor || '#ffffff' };
  return { html: doc.body.innerHTML, color: '#ffffff' };
}

export function packCourseHtml(html, color) {
  const paper = document.createElement('section');
  paper.setAttribute('data-course-paper', 'true');
  paper.style.backgroundColor = color;
  paper.style.padding = '24px';
  paper.style.overflowWrap = 'anywhere';
  paper.innerHTML = sanitizeCourseHtml(html);
  return paper.outerHTML;
}
